<!-- 回执单列表 -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="pageShowData.jurHead" :flagList="['isReceipt']" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
                    <template slot="searchInput" slot-scope="{formOneValue}">
                        <el-select clearable size="mini" v-if="formOneValue.entityField == 'isReceipt'" :disabled="formOneValue.isChange == 0" @change="$forceUpdate()" v-model="getRequestData.isReceipt"
                                   placeholder="请选择">
                            <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key">
                            </el-option>
                        </el-select>
                    </template>
                </v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table v-if="pageShowData.jurTableVo" @sort-change="sortChange" :data="returnData.list" :row-class-name="tableRowClassName" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%"
                      size="mini" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="50" :show-overflow-tooltip="true">
                </el-table-column>
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" :sortable="tableValye.isSort == 1 && tableValye.fieldType == 'number' ? 'custom' : tableValye.isSort == 1 ? true : false"
                                     show-overflow-tooltip :prop="tableValye.entityField" :min-width="tableValye.fieldWeight" :label="tableValye.showField">
                        <template slot-scope="scope">
                            <el-tag size="mini" v-if="tableValye.entityField == 'isWms'">
                                {{ scope.row.isWms == 0 ? '否' : '是' }}
                            </el-tag>
                            <el-tag size="mini" v-else-if="tableValye.entityField == 'isReceipt'">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row.isReceipt) }}</el-tag>
                            <div v-else-if="tableValye.entityField == 'fileUrl'">
                                <div v-if="scope.row.fileUrl">
                                    <cusImage style="width: 20px; height: 20px" v-for="(item, key) in (scope.row.fileUrl ? scope.row.fileUrl.split(',') : [])" :key="key" :src="imgUrl + '/' + item" :preview-src-list="pictureShow(scope.row.fileUrl ? scope.row.fileUrl.split(',').map(item=>{
                                    const info={}
                                    info.fileUrl=item
                                    return info
                                }) : [])">
                                    </cusImage>
                                </div>
                            </div>
                            <span v-else-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                scope.row[tableValye.entityField]
                            }}</a>
                            </span>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" :parentSearchData="parentSearchData" @sendTitle="getSearchName" />
        </el-dialog>
        <div v-if="dialogVisible">
            <el-dialog :visible.sync="dialogVisible" title="登记" append-to-body center width="80%" top="2rem">
                <div class='components_content_box'>
                    <template v-if="formSelect">
                        <el-form label-width="150px" label-position="right" size="mini" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" :show-message="false">
                            <el-row :span="24">
                                <el-col :span="24">
                                    <el-form-item label="回执日期" :rules="[{ required: true, trigger: ['blur', 'change'] }]" prop="receiptTime">
                                        <el-date-picker v-model="sendDataInfo.receiptTime" type="date" size="mini" format="yyyy 年 MM 月 dd 日" value-format="timestamp" placeholder="请选择日期">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" v-if="pLbatch">
                                    <el-form-item label="上传图片">
                                        <el-upload class="upload-demo" :action="requesUrl + '/upload/fileupload'" :headers="token" :multiple="true" :on-success="fileUpload" :before-remove="beforeRemove"
                                                   :before-upload="beforeUpload" :file-list="fileList" :list-type="'picture'">
                                            <el-button size="small" type="primary">点击上传</el-button>
                                            <!-- <div slot="tip" class="el-upload__tip">不超过500kb</div> -->
                                        </el-upload>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <!-- <el-form-item label="到货温度"> 王湘文的客户
                                        <el-input size="mini" v-model="sendDataInfo.remark" type="textarea"></el-input>
                                    </el-form-item> -->
                                    <el-form-item label="备注">
                                        <el-input size="mini" v-model="sendDataInfo.remark" type="textarea"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                        </el-form>
                    </template>
                    <template v-if="!formSelect">
                        <el-form label-width="150px" label-position="right" size="mini" class="baseForm" :model="sendDataInfoTwo" ref="sendDataInfoTwo" :show-message="false">
                            <el-form-item label="临时延长回执日期" :rules="[{ required: true, trigger: ['blur', 'change'] }]" prop="extendTime">
                                <el-date-picker v-model="sendDataInfoTwo.extendTime" type="date" size="mini" format="yyyy 年 MM 月 dd 日" value-format="timestamp" placeholder="请选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-form>
                    </template>
                    <div style="margin-top:.2rem;text-align:center;">
                        <el-button type="primary" @click="initActionBox(formSelect ? 'sendDataInfo' : 'sendDataInfoTwo')">取消
                        </el-button>
                        <el-button type="primary" @click="sendDataAction(formSelect ? 'sendDataInfo' : 'sendDataInfoTwo')">
                            确定</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>

        <printPlan ref="printPlan"></printPlan>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue"
import revokeReceiptReg from "../../../service/api"
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            token: {
                token: sessionStorage.getItem("token"),
            },
            getRequestData: {
                "caiLinker": "",
                "creater": 0,
                "depName": "",
                "ormId": 0,
                "page": 1,
                "rows": 30,
                cmName: '',
                cmId: '',
                start: '',
                end: '',
                wobkemId: '',
                isReceipt: ''
                // start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                // end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: []
            },
            sendDataInfo: {
                reId: [], //	ID
                receiptTime: '', //	回执日期
                remark: '',
                "uploadVoList": [{
                    "fileId": 0,
                    "fileName": "",
                    "fileUrl": "",
                    "type": 0
                }],
            },
            sendDataInfoTwo: { //临时
                reId: '', //	ID
                extendTime: '', //	临时回执日期
            },
            buttonList: [],
            pageShowData: [],
            formDataList: [],
            selectedDataIndex: 0,
            seId: "",
            seTitle: "",
            seWidth: "",
            DialogVisible: false,
            seType: '',
            isShowTooltip: false,
            actionData: {},
            dialogVisible: false,
            fileList: [], //文件
            requesUrl: "",
            imgUrl: "",
            formSelect: false,
            sField: '',
            ormId: '',
            parentSearchData: {},
            selList: [],
            pLbatch: false,

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.cmName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.cmId = "";
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        sortChange(column) {
            this.returnData.list = this.$common.sortChange(column, this.returnData.list, this.pageShowData.jurTableVo.jurconfigtable, 'entityField')
        },
        handleSelectionChange(e) {
            this.selList = e
        },
        tableRowClassName({ row, rowIndex }) {
            if (row.woamType == '专管药品' || row.woamType == '特殊药品' || row.woamType == '蛋肽类' || row.woamType == '终止妊娠药品' || row.woamType == '含麻' || row.woamType == '冷藏药品') {
                return 'warning-row';
            }
            return '';
        },
        showPrintPlan(e) { // 打印方法
            var orderId = e.wobkemId
            var jurid = sessionStorage.getItem('printJurId')
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(orderId, 'printData/pisBookkeeping', jurid)
            } else {
                return
            }
        },
        //图片地址转换
        pictureShow(data) {
            var imgList = [];
            data.forEach((item) => {
                imgList.push(this.imgUrl + '/' + item.fileUrl);
            });
            return imgList;
        },
        //获取当天最后时间
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        // 检索Id, 索引(表格中), 标识
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        //返回数据
        changeInputModel(val) {
            console.log(val);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },

        //上传文件
        async fileUpload(event) {
            // console.log(event);
            if (event.status == 200) {
                event.result.forEach((item) => {
                    this.sendDataInfo.uploadVoList.push(JSON.parse(JSON.stringify(item)))
                })
            } else {
                this.$message({
                    type: 'error',
                    message: event.message
                });

            }
        },
        beforeUpload(file) {
            // console.log(file, this.sendDataInfo.uploadVoList);
            for (let i = 0; i < this.sendDataInfo.uploadVoList.length; i++) {
                const v = this.sendDataInfo.uploadVoList[i]
                if (v.fileName == file.name) {
                    this.$message({
                        type: "error",
                        message: "请勿重复添加",
                    })
                    return false
                }
            }
        },
        beforeRemove(file, fileList) {
            // console.log(file, JSON.parse(JSON.stringify(fileList)),this.sendDataInfo.uploadVoList)
            let index = 0
            for (let i = 0; i < fileList.length; i++) {
                const item = fileList[i];
                if (item.uid == file.uid) {
                    index = i
                    break
                }
            }
            this.sendDataInfo.uploadVoList.splice(index, 1)
        },

        // 动作集合
        actionSet(actionData) {
            console.log('actionData.actionType', actionData.actionType)
            switch (actionData.actionType) {
                case 0:
                    var dataInfo = this.selList
                    if (dataInfo == '' || dataInfo == []) {
                        this.$message({
                            message: '请先选中要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    this.pLbatch = true
                    this.fileList = []
                    if (dataInfo.length == 1) {//
                        for (const key in this.sendDataInfo) {
                            if (key == 'uploadVoList') {
                                // dataInfo[0]['fileUrl'].split(',').forEach((item, index) => {
                                //     this.fileList.push({
                                //         name: item,
                                //         url: this.imgUrl + '/' + item,
                                //     })
                                // })
                                this.$set(this.sendDataInfo, key, [])
                            } else {
                                this.$set(this.sendDataInfo, key, dataInfo[0][key])
                            }
                        }
                        this.sendDataInfo.reId = [this.sendDataInfo.reId]

                        this.formSelect = true
                        this.dialogVisible = true
                    } else {
                        let arr = []
                        let flag = false
                        this.selList.forEach(item => {
                            if (item.isReceipt) {
                                flag = true
                            }
                            arr.push(item.reId)
                        })
                        if (flag) return this.$message.error('存在已上传回执单据，请重新选择')
                        this.sendDataInfo.reId = arr
                        this.formSelect = true
                        this.dialogVisible = true
                    }


                    break;
                case 1:
                    if (this.selList.length == 0) {
                        return this.$message({
                            message: '请选择数据！',
                            type: 'error'
                        });
                    }
                    var dataInfo = this.selList[0]
                    if (!dataInfo) {
                        this.$message({
                            message: '请先选中要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    for (const key in this.sendDataInfoTwo) {
                        this.$set(this.sendDataInfoTwo, key, dataInfo[key])
                    }

                    this.formSelect = false
                    this.dialogVisible = true
                    break;
                case 2:
                    if (this.selList.length != 1) {
                        return this.$message({
                            message: '请选择一条数据！',
                            type: 'error'
                        });
                    }
                    var dataInfo = this.selList[0]
                    if (!dataInfo) {
                        this.$message({
                            message: '请先选中要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    this.autonomousReceipt(dataInfo.reId)
                    break;
                case 3:
                    if (this.selList.length != 1) {
                        return this.$message({
                            message: '请选择一条数据！',
                            type: 'error'
                        });
                    }
                    var dataInfo = this.selList[0]
                    if (!dataInfo) {
                        this.$message({
                            message: '请先选中要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    this.reReceipt(dataInfo)
                    break
                case 8:
                    if (this.selList.length != 1) {
                        return this.$message({
                            message: '请选择一条数据！',
                            type: 'error'
                        });
                    }
                    var dataInfo = this.selList[0]
                    if (!dataInfo) {
                        this.$message({
                            message: '请先选中要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    this.showPrintPlan(dataInfo)
                    break;
                case 9:
                    this.exportData()
                    break;
            }
        },
        //撤销回执登记
        async reReceipt(item) {
            // revokeReceiptReg
            console.log(item)

            let data = {
                "reId": item.reId,
                "uploadVoList": item.uploadVoList
            }
            let res = await this.$http.revokeReceiptReg(data)
            if (res.status == 200) {
                this.$message({
                    message: res.message,
                    type: 'success'
                })
                this.getDataList()
            } else {
                this.$message({
                    message: res.message,
                    type: 'error'
                })
            }

        },
        //  导出
        exportData() {
            this.getRequestData.page = 1
            this.getDataList()
            if (this.returnData.list.length == 0) return this.$message.warning("暂无导出数据")

            window.location.href = this.requesUrl + `/receipt/exportReceiptData${this.$common.getUrl({ ormId: JSON.parse(sessionStorage.getItem("loginInfo")).ormId, ...this.getRequestData })}`
            // window.location.href = this.requesUrl + '/receipt/exportReceiptData?ormId=' + String(this.ormId) + '&cmName=' + this.getRequestData.cmName
            //     + '&cmId=' + this.getRequestData.cmId + '&start=' + this.getRequestData.start + '&end=' + this.getRequestData.end
            //     + '&wobkemId=' + this.getRequestData.wobkemId + '&isReceipt=' + this.getRequestData.isReceipt
            //     + '&page=' + this.getRequestData.page + '&rows=' + this.getRequestData.rows
        },
        autonomousReceipt(id) {
            this.$confirm('确定自主标记回执吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let params = {
                    ids: [id]
                }
                let responseData = await this.$http.autonomousReceipt(params) //临时
                if (responseData.status == 200) {
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    this.getDataList()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }
            }).catch(() => { });
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        //确认新增
        sendDataAction(formName1) {
            this.$refs[formName1].validate((valid) => {
                if (valid) {
                    // console.log('send', this.sendDataInfo)
                    this.sub(formName1)
                } else {
                    this.$message({
                        message: '请完善必填信息',
                        type: 'error'
                    })
                    return false;
                }
            })
        },
        async sub(formName1) {
            var responseData
            if (this.formSelect) {
                console.log(this.sendDataInfo)
                responseData = await this.$http.receiptRegisterReceipt(this.sendDataInfo) //回执
            } else {
                let sendDataInfoList = []
                this.selList.forEach(item => {
                    let subItem = {
                        reId: item.reId,
                        extendTime: this.sendDataInfoTwo.extendTime
                    }
                    sendDataInfoList.push(subItem)
                })
                console.log(sendDataInfoList)
                responseData = await this.$http.receiptPostponeReceipt(sendDataInfoList) //临时
            }

            if (responseData.status == 200) {
                this.init()
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.$refs[formName1].resetFields()
                this.dialogVisible = false
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        //取消
        initActionBox(formName1) {
            this.$confirm('确定取消登记吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.init()
                this.$refs[formName1].resetFields()
                this.dialogVisible = false
            }).catch(() => { });
        },
        //初始化
        init() {
            if (this.actionData.actionType == 0) {
                for (let key in this.sendDataInfo) {
                    if (key == 'reiDate') {
                        this.sendDataInfo[key] = this.$moment().valueOf()
                    } else {
                        this.sendDataInfo[key] = ''
                    }
                }
            } else {
                for (let key in this.sendDataInfoTwo) {
                    if (key == 'reiDate') {
                        this.sendDataInfo[key] = this.$moment().valueOf()
                    } else {
                        this.sendDataInfo[key] = ''
                    }
                }
            }

        },
        // showPrintPlan() {
        //     var dataInfo = this.returnData.list[this.selectedDataIndex]
        //     if (!dataInfo) {
        //         this.$message({
        //             message: '请先选中要操作的数据',
        //             type: 'error'
        //         });
        //         return false
        //     }
        //     // 调用全局方法 判断Websocket是否连接
        //     if (this.$printSocketApi.printExeMsg() != false) {
        //         // 选中的数据
        //         var info = this.returnData.list[this.selectedDataIndex]
        //         this.$refs.printPlan.openDia(info.vrId)
        //     } else {
        //         return
        //     }
        // },
        // // 删除数据
        // delDataAction() {
        //     var dataInfo = this.returnData.list[this.selectedDataIndex]
        //     if (!dataInfo) {
        //         this.$message({
        //             message: '请先选中要操作的数据',
        //             type: 'error'
        //         });
        //         return false
        //     }

        //     this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        //         confirmButtonText: '确定',
        //         cancelButtonText: '取消',
        //         type: 'warning'
        //     }).then(async () => {
        //         var delData = {
        //             ids: [dataInfo.vrId]
        //         }
        //         let responseData = await this.$http.visitorDelete(delData)
        //         if (responseData.status == 200) {
        //             this.$message({
        //                 type: 'success',
        //                 message: '删除成功!'
        //             });

        //             this.getDataList()
        //         } else {
        //             this.$message({
        //                 message: responseData.message,
        //                 type: 'error'
        //             });
        //         }

        //     }).catch(() => {});
        // },

        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },

        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path)
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            })
            if (responseData.status == 200) {
                this.pageShowData = responseData.result
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.formDataList = this.pageShowData.jurFormVoList
                this.getDataList();
                this.getButtonList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.receiptQueryReceipt(this.getRequestData)
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list
                this.returnData.pages = responseData.result.pages
                this.returnData.total = responseData.result.total
                this.returnData.pageNum = responseData.result.pageNum
                // this.selectedDataIndex = 0
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        //图片所需路径
        imgur() {
            // console.log(this.$store.getters.getConfig);
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },

        //获取状态
        getIsGsp(str, val) {
            try {
                if (str.indexOf('[') === -1) return val
                str && str.replace(/\\/g, '')
                let arr = JSON.parse(str)
                let len = arr.length
                let newStr = ''
                for (let i = 0; i < len; i++) {
                    if (arr[i].key == val) {
                        newStr = arr[i].value
                        break;
                    }
                }
                return newStr ? newStr : val
            } catch (ex) {
                return val
            }
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getRequestData.ormId = JSON.parse(sessionStorage.getItem("loginInfo")).ormId;
        this.getPageInfo()
        this.getButtonList()
        this.imgur()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.el-drawer {
    outline: none;
}
</style>
<style>
.el-table .warning-row {
    background: rgb(247, 222, 176);
}
</style>